import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'contract_workers_workers_employed_third_party_who_are'

export const dataPointDefinition = {
  retracedId: 'contract_workers_workers_employed_third_party_who_are',
  name: 'Contract workers/ workers employed by third party who are not part of the production process',
  description:
    '"Contract workers/ workers employed by third party who are not part of the production process" refers to persons not working on/with the facility\'s product or directly involved in the operations of the facility and who are under contract with an organization other than the facility to work at the fa',
  meta: {
    slcpMeta: {
      key: 'wi-gri-29',
      number: 'WI-GRI-22',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wi-gri-29', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36760,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
